import * as React from 'react';
import '@styles/pages/public.scss';
import { AreaInfo } from '@/fetch.ts';
import AnchorDetect from 'react-anchor-scroll-detect';
interface PropType {
  list: AreaInfo[],
  showHour: boolean,
}
const { useState, useEffect } = React;

const SideBar: React.FC<PropType> = props => {
  const [showSide, ShowSide] = useState<boolean>(false);
  useEffect(() => {
    const isChrome = window.navigator.userAgent.indexOf('Chrome') > -1;
    if (isChrome) {
      $(window).on('scroll', handleScroll);
    }
  }, [])
  const handleScroll = () => {
    const marginH: any = $(window).scrollTop();
    if (marginH >= 935 && document.body.offsetWidth > 1600) {
      ShowSide(true);
    }
    if (marginH <= 935 && document.body.offsetWidth > 1600) {
      ShowSide(false);
    }
  }
  return showSide ? (
    <AnchorDetect
      className="sideBar"
      items={['toHour', ...props.list.map((item: AreaInfo) => ('area' + item.iArea))]}
      activeClass="active"
      offsetTop={100}
    >
      {
        props.showHour && <a>小时冠军</a>
      }
      {
        props.list.map((item: AreaInfo) => (
          <a
            key={item.iArea}
          >{item.sName}</a>
        ))
      }
      <a href='#'>Top</a>
    </AnchorDetect>
  ) : null;
}

export default SideBar;